var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8956",
    fill: "none",
    stroke: "#707070",
    d: "M0 0H32V32H0z",
    transform: "translate(468 421)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-4,.cls-5{fill:#265697;fillRule:evenodd}.cls-5{fill:#d97b16}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58097",
    clipPath: "url(#clip-path)",
    transform: "translate(-468 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(472 429.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-20",
    fill: "#f6f6f6",
    d: "M0 0H24V12H0z",
    transform: "translate(0 1.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1",
    d: "M22.2 0h-21A1.29 1.29 0 0 0 0 1.2V3h24V1.8A1.591 1.591 0 0 0 22.2 0zm0 0",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1-2",
    d: "M0 12v1.2A1.591 1.591 0 0 0 1.8 15h20.4a1.591 1.591 0 0 0 1.8-1.8V12zm0 0",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.742 4.467a4.3 4.3 0 0 0-1.521-.267c-1.678 0-2.859.863-2.869 2.1-.009.915.844 1.425 1.488 1.729.661.312.883.511.88.789 0 .427-.528.622-1.016.622a3.5 3.5 0 0 1-1.6-.334l-.219-.1-.238 1.425a5.273 5.273 0 0 0 1.891.34c1.785 0 2.943-.853 2.956-2.174.006-.724-.446-1.275-1.425-1.729-.593-.294-.957-.491-.953-.789 0-.265.308-.547.972-.547a3.074 3.074 0 0 1 1.271.244l.152.073.23-1.379",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M21.1 4.317h-1.316a.842.842 0 0 0-.889.528l-2.521 5.833h1.783s.291-.784.357-.956h2.174c.051.223.207.954.207.954h1.575L21.1 4.317zM19 8.419l.676-1.779c-.01.017.139-.368.225-.607l.115.549.393 1.838zm0 0",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M8.887 10.675l1.062-6.364h1.7l-1.062 6.365zm0 0",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    d: "M7.464 4.315L5.8 8.655l-.177-.882A4.933 4.933 0 0 0 3.273 5.1l1.52 5.566h1.8l2.669-6.351h-1.8",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    d: "M4.259 4.311H1.522l-.022.133a5.647 5.647 0 0 1 4.124 3.33l-.6-2.925a.712.712 0 0 0-.77-.537",
    className: "cls-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bd5ae2883092ed2a6089c072fa9d541f.svg";
export { ForwardRef as ReactComponent };